export function hardRedirect(path) {
  if (!path) {
    return;
  }

  const target = path.startsWith("/") ? path : `/${path}`;
  const current = `${window.location.pathname}${window.location.search}`;

  if (current === target || window.location.pathname === target) {
    return;
  }

  window.location.replace(target);
}
